import request from '@/utils/request'
import { getCommunityId } from '@/api/community/communityApi'

const STATE_MAP = {
  'PENDING': '待受理',
  'ACCEPTED': '受理中',
  'SCHEDULED': '调解排期',
  'IN_PROGRESS': '调解进行中',
  'AGREED': '达成协议',
  'TERMINATED': '调解终止',
  'ARCHIVED': '已归档'
}

const STATE_TAG_TYPE = {
  'PENDING': 'info',
  'ACCEPTED': '',
  'SCHEDULED': 'success',
  'IN_PROGRESS': 'warning',
  'AGREED': 'success',
  'TERMINATED': 'danger',
  'ARCHIVED': 'info'
}

const EVENT_TYPE_MAP = {
  '1000': '提交申请',
  '1001': '受理审查',
  '1002': '指派调解员',
  '1003': '更换调解员',
  '1004': '调解过程',
  '1005': '达成协议',
  '1006': '调解终止',
  '1007': '案件归档',
  '1008': '回访记录',
  '1009': '线上留言'
}

export function stateToName(state) {
  return STATE_MAP[state] || state || ''
}

export function stateToTagType(state) {
  return STATE_TAG_TYPE[state] || 'info'
}

export function eventTypeToName(type) {
  return EVENT_TYPE_MAP[type] || '其他'
}

// 后台案件列表
export function listMediationCases(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/mediation.listCases',
      method: 'get',
      params: {
        ...params,
        communityId: getCommunityId()
      }
    }).then(response => {
      resolve(response.data)
    }).catch(error => {
      reject(error)
    })
  })
}

// 案件详情
export function getMediationCaseDetail(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/mediation.getCaseDetail',
      method: 'get',
      params
    }).then(response => {
      resolve(response.data)
    }).catch(error => {
      reject(error)
    })
  })
}

// 受理审查
export function auditMediationApply(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/mediation.auditApply',
      method: 'post',
      data: {
        ...data,
        communityId: getCommunityId()
      }
    }).then(response => {
      resolve(response.data)
    }).catch(error => {
      reject(error)
    })
  })
}

// 指派调解员
export function assignMediator(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/mediation.assignMediator',
      method: 'post',
      data: {
        ...data,
        communityId: getCommunityId()
      }
    }).then(response => {
      resolve(response.data)
    }).catch(error => {
      reject(error)
    })
  })
}

// 更换调解员
export function changeMediator(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/mediation.changeMediator',
      method: 'post',
      data: {
        ...data,
        communityId: getCommunityId()
      }
    }).then(response => {
      resolve(response.data)
    }).catch(error => {
      reject(error)
    })
  })
}

// 调解过程记录
export function saveMediationProcess(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/mediation.saveProcess',
      method: 'post',
      data: {
        ...data,
        communityId: getCommunityId()
      }
    }).then(response => {
      resolve(response.data)
    }).catch(error => {
      reject(error)
    })
  })
}

// 达成协议
export function saveMediationAgreement(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/mediation.saveAgreement',
      method: 'post',
      data: {
        ...data,
        communityId: getCommunityId()
      }
    }).then(response => {
      resolve(response.data)
    }).catch(error => {
      reject(error)
    })
  })
}

// 调解终止
export function terminateMediation(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/mediation.terminate',
      method: 'post',
      data: {
        ...data,
        communityId: getCommunityId()
      }
    }).then(response => {
      resolve(response.data)
    }).catch(error => {
      reject(error)
    })
  })
}

// 归档
export function archiveMediation(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/mediation.archive',
      method: 'post',
      data: {
        ...data,
        communityId: getCommunityId()
      }
    }).then(response => {
      resolve(response.data)
    }).catch(error => {
      reject(error)
    })
  })
}

// 回访记录
export function saveMediationVisit(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/mediation.saveVisit',
      method: 'post',
      data: {
        ...data,
        communityId: getCommunityId()
      }
    }).then(response => {
      resolve(response.data)
    }).catch(error => {
      reject(error)
    })
  })
}

// ============ 调解纠纷类型管理 ============

// 查询纠纷类型列表（含关联调解员）
export function listDisputeTypes(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/mediation.listDisputeTypes',
      method: 'get',
      params: {
        communityId: getCommunityId(),
        ...params
      }
    }).then(response => {
      resolve(response.data)
    }).catch(error => {
      reject(error)
    })
  })
}

// 保存纠纷类型（含关联调解员）
export function saveDisputeType(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/mediation.saveDisputeType',
      method: 'post',
      data: {
        ...data,
        communityId: getCommunityId()
      }
    }).then(response => {
      resolve(response.data)
    }).catch(error => {
      reject(error)
    })
  })
}

// 更新纠纷类型
export function updateDisputeType(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/mediation.updateDisputeType',
      method: 'post',
      data: {
        ...data,
        communityId: getCommunityId()
      }
    }).then(response => {
      resolve(response.data)
    }).catch(error => {
      reject(error)
    })
  })
}

// 删除纠纷类型
export function deleteDisputeType(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/mediation.deleteDisputeType',
      method: 'post',
      data
    }).then(response => {
      resolve(response.data)
    }).catch(error => {
      reject(error)
    })
  })
}

// ============ 调委会管理 ============

// 查询调委会列表
export function listCommittees(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/mediation.listCommittees',
      method: 'get',
      params: {
        communityId: getCommunityId(),
        ...params
      }
    }).then(response => {
      resolve(response.data)
    }).catch(error => {
      reject(error)
    })
  })
}

// 保存调委会
export function saveCommittee(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/mediation.saveCommittee',
      method: 'post',
      data: {
        ...data,
        communityId: getCommunityId()
      }
    }).then(response => {
      resolve(response.data)
    }).catch(error => {
      reject(error)
    })
  })
}

// 更新调委会
export function updateCommittee(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/mediation.updateCommittee',
      method: 'post',
      data: {
        ...data,
        communityId: getCommunityId()
      }
    }).then(response => {
      resolve(response.data)
    }).catch(error => {
      reject(error)
    })
  })
}

// 删除调委会
export function deleteCommittee(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/mediation.deleteCommittee',
      method: 'post',
      data
    }).then(response => {
      resolve(response.data)
    }).catch(error => {
      reject(error)
    })
  })
}

// ============ 合并受理+指派 / 不予调解 ============

// 同意调解（合并受理+指派调解员）
export function acceptMediationCase(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/mediation.acceptCase',
      method: 'post',
      data: {
        ...data,
        communityId: getCommunityId()
      }
    }).then(response => {
      resolve(response.data)
    }).catch(error => {
      reject(error)
    })
  })
}

// 不予调解
export function rejectMediationCase(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/mediation.rejectCase',
      method: 'post',
      data
    }).then(response => {
      resolve(response.data)
    }).catch(error => {
      reject(error)
    })
  })
}

// ============ 调解数据统计 ============

// 调解数据统计
export function queryMediationStatistics(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/mediation.queryStatistics',
      method: 'get',
      params
    }).then(response => {
      resolve(response.data)
    }).catch(error => {
      reject(error)
    })
  })
}
